import type { ReactNode }      from 'react';
import FormattedMessageWrapper from 'components/App/FormattedMessageWrapper';

export interface Language {
	label: ReactNode;
	reference: string;
	shortLabel: ReactNode;
	value: string;
}

export const FR: Language = {
  label: <FormattedMessageWrapper id="Français" />,
  reference: 'fr',
  shortLabel: <FormattedMessageWrapper id="Fr" />,
  value: 'fr',
};

export const EN: Language = {
  label: <FormattedMessageWrapper id="Anglais" />,
  reference: 'en',
  shortLabel: <FormattedMessageWrapper id="En" />,
  value: 'en',
};

const Languages: Language[] = [FR, EN];

export const getLabel = (value: string | null): ReactNode => {
  const lang = Languages.find(lng => lng.value === value);
	return lang ? lang.label : '';
};

export const getShortLabel = (value: string): ReactNode => {
  const lang = Languages.find(lng => lng.value === value);
	return lang ? lang.shortLabel : null;
};

export default Languages;